class DatePicker {

    static defaultDatePickerOptions(onSelect) {

        return {
            minDate: 0,
            dateFormat: "dd/mm/yy",
            monthNames: [
                Translator.trans("TR_ENERO"),
                Translator.trans("TR_FEBRERO"),
                Translator.trans("TR_MARZO"),
                Translator.trans("TR_ABRIL"),
                Translator.trans("TR_MAYO"),
                Translator.trans("TR_JUNIO"),
                Translator.trans("TR_JULIO"),
                Translator.trans("TR_AGOSTO"),
                Translator.trans("TR_SEPTIEMBRE"),
                Translator.trans("TR_OCTUBRE"),
                Translator.trans("TR_NOVIEMBRE"),
                Translator.trans("TR_DICIEMBRE"),
            ],
            dayNamesMin: [
                Translator.trans("TR_CALENDARIO_DOMINGO"),
                Translator.trans("TR_CALENDARIO_LUNES"),
                Translator.trans("TR_CALENDARIO_MARTES"),
                Translator.trans("TR_CALENDARIO_MIERCOLES"),
                Translator.trans("TR_CALENDARIO_JUEVES"),
                Translator.trans("TR_CALENDARIO_VIERNES"),
                Translator.trans("TR_CALENDARIO_SABADO")
            ],
            onSelect: onSelect
        }

    }

}